import React from "react"

function CustomDivider() {
  return <div className="border stroke-primaryGrey-50 stroke-1"></div>
}

export default CustomDivider
